export default __webpack_public_path__ + "static/media/Drought 21aa2a09efb14fd99f6f21e1fd820e0f.825f231b.md";